import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type CarerDetails = {
  id: string;
  email: string;
  name: string;
  photo_url?: string;
  bio?: string;
  care_types?: string[];
  skills?: string[];
  hourly_rate?: number;
  service_area?: string;
  availability_dates?: any;
  verification_status: string;
  dbs_document_url?: string;
  insurance_document_url?: string;
  created_at: string;
  has_requested_intro_call: boolean;
  has_completed_intro_call: boolean;
};

const useCarerDetails = (carerId: string) => {
  const queryFn = async (): Promise<CarerDetails> => {
    const { data, error } = await supabaseClient.functions.invoke('get_carer_details', {
      method: 'POST',
      body: { carer_id: carerId },
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.carer;
  };

  return useQuery<CarerDetails, Error>({
    queryKey: ['carer', carerId],
    queryFn,
    enabled: !!carerId,
  });
};

export default useCarerDetails;
